import { Icon, Menu } from '@atom/mui';
import { DeleteIcon, EditIcon } from '@atom/mui/icons';
import { TaskField } from '@atom/types/task';

const { MenuItem } = Menu;

interface Props {
  field: TaskField;
  onEdit: (field: TaskField) => void;
  onDelete: (field: TaskField) => void;
}

const styles = {
  icon: {
    marginRight: '0.5rem',
  },
};

const TaskFieldMenu = ({ field, onEdit, onDelete }: Props) => {
  const handleEditClick = (selectedField: TaskField) => {
    onEdit(selectedField);
  };

  const handleDeleteClick = (selectedField: TaskField) => {
    onDelete(selectedField);
  };

  return (
    <Menu dataCyLabel={`taskFieldMenu-${field.title}`}>
      <MenuItem
        onClick={() => handleEditClick(field)}
        data-cy={`taskFieldEdit-${field.title}`}
      >
        <Icon style={styles.icon} icon={EditIcon} />
        Edit
      </MenuItem>
      <MenuItem
        onClick={() => handleDeleteClick(field)}
        data-cy={`taskFieldDelete-${field.title}`}
      >
        <Icon style={styles.icon} icon={DeleteIcon} />
        Delete
      </MenuItem>
    </Menu>
  );
};

export default TaskFieldMenu;
